import { withStyles } from '@material-ui/core/styles'
import { get } from 'lodash'
import { connect } from 'react-redux'

import { auth, formSettings, payment, stripe, teams } from '../../../../constants/actions'
import { getFormSettings, getIsAuthenticated, getTeamsByUser, getTeamsInEvent } from '../../../../selectors'
import PaymentCompleteComponent from './component'

const styles = () => ({
  bg: {
    width: '100vw',
    height: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    position: 'fixed',
    zIndex: -9999,
  },
})

const mapStateToProps = state => ({
  paymentStatus: get(state, 'stripe.paymentStatus'),
  orderStatus: get(state, 'payment.orderStatus'),
  formSettings: getFormSettings(state),
  teamsByUser: getTeamsByUser(state),
  teamsInEvent: getTeamsInEvent(state),
  showLoadingIndicator: get(state, 'common.showLoadingIndicator'),
  loadingIndicatorContent: get(state, 'common.loadingIndicatorContent'),
  isAuthenticated: getIsAuthenticated(state),
  userName: get(state, 'auth.user.userName'),
  formType: get(state, 'formSettings.formType'),
  formError: get(state, 'formSettings.formError'),
  publicCert: get(state, 'auth.publicCert'),
  isCheckingAuth: get(state, 'auth.isCheckingAuth'),
})

export default connect(mapStateToProps, {
  getPaymentStatus: stripe.getPaymentStatus,
  getOrderStatus: payment.getOrderStatus,
  getFormSettings: formSettings.getFormSettings,
  getTeamsByUser: teams.getTeamsByUser,
  getTeamsInEvent: teams.getTeamsInEvent,
  getPublicCert: auth.getPublicCert,
  signout: auth.signout,
  setFormSettings: formSettings.setFormSettings,
  setFormSubdomain: formSettings.setFormSubdomain,
  checkAuth: auth.checkAuth,
})(withStyles(styles)(PaymentCompleteComponent))
